export const config = {
  title: "A&R Fencing | Professional Fencing Solutions",
  meta: {
    description:
      "A&R Fencing provides high-quality residential and commercial fencing services, including wood farm fences, privacy fences, shadow box fences, chain link fences, and aluminum fences.",
    keywords: [
      'A&R Fencing',
      'Fencing Services',
      'Wood Farm Fences',
      'Privacy Fences',
      'Shadow Box Fences',
      'Chain Link Fences',
      'Aluminum Fences',
      'Fence Installation',
      'Residential Fencing',
      'Commercial Fencing'
    ],
    author: "A&R Fencing",
    canonicalUrl: 'https://www.anrfencing.com/',
  },
  sections: {
    header: {
      businessName: "A&R Fencing",
    },
    sectionB: {
      heroTitle: "A&R Fencing",
      heroSubtitle: 'Craftsmanship in Every Fence',
      learnAboutText: 'Explore Our Fencing Services',
      phoneNumber: '7316977669',
      phoneLabel: '(731) 697-7669',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1141626538/photo/fencing-worker-installing-metal-wire-mesh-fence-panel.jpg?s=612x612&w=0&k=20&c=4Hh94lKtWrlmFjpqmhGftCI7Mram5GKAC8HOjNe-Jlw=",
      cardData: [
        {
          title: 'Quality Materials',
          description: 'We use only the highest quality materials to ensure durability and longevity in every fence we build.',
        },
        {
          title: 'Satisfaction Guaranteed',
          description: 'Our commitment to excellence guarantees customer satisfaction with every project.',
        },
        {
          title: 'Affordable Prices',
          description: 'We offer competitive pricing without compromising on quality.',
        },
      ],
      description:
        "At A&R Fencing, we specialize in constructing a wide range of fences, including wood farm fences, privacy fences, shadow box fences, chain link fences, and aluminum fences. Our experienced team delivers exceptional workmanship for both residential and commercial markets.",
    },
    sectionC: {
      servicesTitle: 'Our Fencing Services',
      servicesDescription:
        "Discover the variety of fencing solutions we offer to meet your specific needs.",
      cards: [
        {
          title: 'Wood Farm Fences',
          description:
            'Classic and durable wood farm fences that provide both functionality and aesthetic appeal.',
          imageSrc: 'https://static.wixstatic.com/media/fd661e_ecee2fae9edc42aa8b5cbb487cafc95e~mv2.jpg/v1/fill/w_619,h_362,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Video%20Apr%2006%202022%2C%205%2013%2006%20PM_00_00_05_07_Still001.jpg',
          imageAlt: 'Wood Farm Fence',
        },
        {
          title: 'Privacy Fences',
          description:
            'Secure and private fencing solutions to enhance the seclusion of your property.',
          imageSrc: 'https://static.wixstatic.com/media/fd661e_f3e6a5a1918b4414aaa8848bc4a62f4d~mv2.jpg/v1/fill/w_626,h_360,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7xx.jpg',
          imageAlt: 'Privacy Fence',
        },
        {
          title: 'Chain Link Fences',
          description:
            'Cost-effective and durable chain link fences suitable for various applications.',
          imageSrc: 'https://media.istockphoto.com/id/1345761170/photo/chain-link-fence-along-an-empty-sidewalk-with-a-row-of-old-homes-in-astoria-queens-new-york.jpg?s=612x612&w=0&k=20&c=tL3tGuYKEhOy74jhePXZO0OKYIaPZSL_I5jyEAW7-lY=',
          imageAlt: 'Chain Link Fence',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Shadow Box Fences',
        'Aluminum Fences',
        'Gate Installation',
        'Custom Fencing Solutions',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/fd661e_091196cf9f1740f2abfbfe8b4f288b33~mv2.jpg/v1/fill/w_1259,h_421,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/fd661e_091196cf9f1740f2abfbfe8b4f288b33~mv2.jpg',
        alt: "A&R Fencing Team",
      },
      aboutText: [
        "A&R Fencing is a dedicated fencing company with years of experience in the industry.",
        "We pride ourselves on delivering high-quality workmanship and exceptional customer service for both residential and commercial clients.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "A&R Fencing Logo",
      businessName: "A&R Fencing",
      contact: {
        phone: '7316977669',
        phoneLabel: '(731) 697-7669',
        email: 'arellanesr37@gmail.com',
        website: 'https://www.anrfencing.com/',
        address: '854 Colvett Road Alamo, TN 38001, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: '854 Colvett Road Alamo, TN 38001, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d-77.436048!3d37.540725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b111234567890b%3A0x1234567890abcdef!2s854%20Colvett%20Road%20Alamo%2C%20TN%2038001%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
